import { render, staticRenderFns } from "./extra-fodyn-field.vue?vue&type=template&id=4042b890&scoped=true&lang=pug&"
import script from "./extra-fodyn-field.vue?vue&type=script&lang=js&"
export * from "./extra-fodyn-field.vue?vue&type=script&lang=js&"
import style0 from "./extra-fodyn-field.vue?vue&type=style&index=0&id=4042b890&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4042b890",
  null
  
)

export default component.exports